export default __webpack_public_path__ + "static/GayleAlvarez-59bf71b35457568830190dc8c994edd1.jpg";